<template>
  <div class="buybox__atc">
    <div v-if="isTest && product.template === 'test-buy-box'" class="buybox__atc-qty">
      <button type="button" aria-label="Decrease item quantity" class="buybox__atc-qty-button" @click="decrementQuantity()">
        <svg class="icon icon--xs">
          <use href="#minus"></use>
        </svg>
      </button>
      {{ cartQuantity }}
      <button type="button" aria-label="Increase item quantity" class="buybox__atc-qty-button" @click="incrementQuantity()">
        <svg class="icon icon--xs">
          <use href="#plus"></use>
        </svg>
      </button>
    </div>
    <button class="btn btn--primary btn--solid" @click="atc()" :disabled="!selectedVariant.available || selectedVariant.sold_out">
      {{ buttonText }}
    </button>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    isMultiPack: {
      type: Boolean,
      default: false, 
    },

    selectedVariant: {
      type: Object,
      default: null,
    },

    selectedSellingPlan: {
      type: Object,
      default: null,
    },

    isSubscription: {
      type: Boolean,
      default: false, 
    },

    isTest: {
      type: Boolean,
      default: false, 
    }
  })

  const { product, isMultiPack, selectedVariant, selectedSellingPlan, isSubscription, isTest } = toRefs(props);
  const emit = defineEmits(['track-event','toggle-option-drawer']);

  const buttonText = computed(() => {
    if(selectedVariant?.value?.available && !selectedVariant.value?.sold_out) {
      return `Add to Bag - ${getSelectedVariantPrice.value}`
    } else{
      return 'Sold Out'
    }
  })

  const getSelectedVariantPrice = computed(() => {
    const item = selectedVariant.value;

    if (window.shopLocation !== 'GB' && isMultiPack.value) {
      return window.formattedPrice(item.price / 100);
    } else {
      if(isSubscription.value) {
        const sellingPlan = item.selling_plans.find(plan => plan.selling_plan.id === selectedSellingPlan.value.id);
        if (sellingPlan) {
          return window.formattedPrice((sellingPlan.per_delivery_price / 100).toFixed(2));
        }
      }

      return window.formattedPrice((item.price / 100).toFixed(2));
    }
  })

  const cartQuantity = ref(1);

  /*-- Test [template: test-buy-box] - start --*/
  function incrementQuantity() {
    cartQuantity.value++;
  }

  function decrementQuantity() {
    cartQuantity.value--;
  }
  /*-- Test [template: test-buy-box] - end --*/

  const atc = async() => {
    window.openCart();
    emit('toggle-option-drawer');
    await window.Additem({
      id: selectedVariant.value.id,
      quantity: cartQuantity.value ? cartQuantity.value : 1,
      ...(isSubscription.value) && {selling_plan: selectedSellingPlan.value.id}
    })
    emit('track-event',isSubscription.value ? 'Added Subscription to Cart' : 'Added One-Time to Cart')
  }
</script>